
import axios from 'axios';


require("linqjs");

export default {
  state: () => ({
  
   
  }),
  mutations: {
  
  },
  getters: {
  
  },
  actions: {
async ServicesFee(context, params) {
    try {
        const res =  await  axios.post("http://localhost:56363/api/v1/CIP/GetServicesFee" ,params, {
            headers: {
                "Content-type":"application/json"
                 }});
            return res.data;
        } catch (err) {
            console.log(err);
        }
},
    async ServicesCategories() {
        try {
           
        const res =  await  axios.post("http://localhost:56363/api/v1/CIP/GetServicesCategories" , {
            headers: {
                "Content-type":"application/json"
                 }});
            return res.data;
        } catch (err) {
            console.log(err);
        }
        
      
          
    
  },

   
  },
};
